var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM5.8116 13.7967L7.60588 12L5.81093 10.1873L4 12L5.8116 13.7967ZM15.0827 10.7027L11.9923 7.60933L8.90195 10.7187L7.09037 8.90668L11.9923 4L16.8943 8.89068L15.0827 10.7027ZM16.3788 12L18.1737 10.1873L20 12L18.1897 13.8127L16.3788 12ZM8.90195 13.2813L11.9923 16.3907L15.0827 13.2813L16.8943 15.0933L11.9923 20L7.09037 15.094L8.90195 13.2813ZM13.8033 11.984L11.9923 13.7973V13.7967L10.1814 12L11.9923 10.188L13.8033 11.984Z",
    fill: "#646464"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.213f41cb3e447c444ddbe18930105202.svg";
export { ForwardRef as ReactComponent };